function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (_ref) {
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries,
    sizes = _ref.sizes;
  return {
    base: _defineProperty({
      backgroundColor: colors.white,
      padding: '30px',
      borderRadius: '10px',
      position: 'relative',
      '&.hoverable': {
        transition: 'all .2s ease-in-out',
        cursor: 'pointer'
      },
      '&.hoverable:hover': {
        boxShadow: '0 0 11px 0 rgba(0,0,0,0.18)'
      }
    }, mediaQueries.breakpointTablet, {
      borderRadius: 0,
      padding: " 30px ".concat(sizes.gutterWidth, "px")
    })
  };
});